import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Files } from '../../services/journey.service';
import { useGetMyPersonalFilesMutation } from '../../services/me.service';
import { updateFiles } from '../../features/journey';
import MyFilesV2Model from './model';

let filesLoadedCache = false;
let cachedPersonalFiles: Files | null = null;
let pendingFetch: Promise<Files> | null = null;

export const resetMyFilesCache = () => {
  filesLoadedCache = false;
  cachedPersonalFiles = null;
  pendingFetch = null;
};

export default function MyFilesV2ViewModel() {
  const [getPersonalFiles, { isLoading }] = useGetMyPersonalFilesMutation();
  const dispatch = useDispatch();
  const [files, setFiles] = useState<Files | null>(cachedPersonalFiles);
  const [error, setError] = useState(false);
  const [visibleCount, setVisibleCount] = useState(2);

  useEffect(() => {
    if (filesLoadedCache && !pendingFetch) return;

    if (!pendingFetch) {
      filesLoadedCache = true;
      pendingFetch = getPersonalFiles({}).unwrap() as Promise<Files>;
    }

    pendingFetch
      .then(res => {
        cachedPersonalFiles = res;
        pendingFetch = null;
        dispatch(updateFiles(res));
        setFiles(res);
        setError(false);
      })
      .catch(() => {
        filesLoadedCache = false;
        pendingFetch = null;
        setError(true);
      });
  }, []);

  const allFilesSorted = useMemo(
    () => (files ? MyFilesV2Model.sortByDate(MyFilesV2Model.mergeAllFiles(files)) : []),
    [files]
  );

  const maxVisibleCount = Math.min(10, allFilesSorted.length);
  const recentFiles = allFilesSorted.slice(0, visibleCount);
  const hasMore = visibleCount < allFilesSorted.length && visibleCount < maxVisibleCount;
  /**
   * @description Load more, carrega mais arquivos, aumentando a contagem visível em 10, mas não excedendo 10
   */
  const loadMore = () => setVisibleCount(v => Math.min(v + 10, maxVisibleCount));

  return { isLoading, error, files, recentFiles, hasMore, loadMore, allFilesSorted };
}
